<template>
  <div class="rounded-card magicpattern p-8 md:p-16 text-white overflow-hidden">
    <div class="max-w-2xl mx-auto text-center">
      <span class="inline-block rounded-badge bg-secondary text-primary text-xs font-medium tracking-label uppercase px-3 py-1">
        Sınırlı Erken Erişim
      </span>
      <h2 class="mt-6 text-3xl md:text-4xl lg:text-5xl font-medium leading-[1] tracking-display">
        İlk 500 kişiye özel fırsat.
      </h2>
      <p class="mt-6 text-stone text-base md:text-lg leading-relaxed">
        Bekleme listesine ilk 500 kayıt olan kişiye, lansmanda
        <span class="text-secondary font-medium">indirimli komisyon ile yatırım fırsatı</span>
        sunulacaktır.
      </p>

      <form @submit.prevent="submitForm" class="mt-10 flex flex-col sm:flex-row gap-3 items-stretch max-w-lg mx-auto">
        <input
          type="email"
          v-model="email"
          required
          placeholder="E-posta adresin"
          class="flex-1 px-5 py-4 rounded-btn bg-white text-primary placeholder:text-graphite border border-white focus:outline-none focus:border-secondary"
        />
        <button
          type="submit"
          class="inline-flex items-center justify-center px-6 py-4 rounded-btn border border-secondary bg-secondary text-primary text-base font-medium hover:bg-cream hover:border-cream transition-colors whitespace-nowrap disabled:opacity-60 disabled:cursor-not-allowed"
          :disabled="loading"
        >
          {{ loading ? 'Gönderiliyor…' : 'Listeye Katıl →' }}
        </button>
      </form>

      <p
        v-if="message"
        :class="success ? 'text-secondary' : 'text-coral'"
        class="text-center mt-6 text-sm font-medium"
      >
        {{ message }}
      </p>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, ref } from 'vue';
import axios from 'axios';

export default defineComponent({
  name: 'WaitListForm',
  setup() {
    const email = ref<string>("");
    const loading = ref<boolean>(false);
    const message = ref<string>("");
    const success = ref<boolean>(false);

    const SUPABASE_URL = "https://wehmgdcvztjpilyjasgz.supabase.co";
    // Anon (public) key — Supabase Dashboard → Project Settings → API → "anon public"
    const SUPABASE_ANON_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6IndlaG1nZGN2enRqcGlseWphc2d6Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3Nzg2NzgzNTUsImV4cCI6MjA5NDI1NDM1NX0.kpBvD1alcBTmLVHaLYtZ1TRN1QfMwwWNn1z-zlAwrP8";

    const isValidEmail = (value: string) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);

    const submitForm = async () => {
      const trimmed = email.value.trim().toLowerCase();
      if (!isValidEmail(trimmed)) {
        message.value = "Lütfen geçerli bir e-posta gir.";
        success.value = false;
        return;
      }

      loading.value = true;
      message.value = "";

      try {
        await axios.post(
          `${SUPABASE_URL}/rest/v1/waitlist`,
          {
            email: trimmed,
            source: "website",
          },
          {
            headers: {
              "Content-Type": "application/json",
              apikey: SUPABASE_ANON_KEY,
              Authorization: `Bearer ${SUPABASE_ANON_KEY}`,
              Prefer: "return=minimal",
            },
          }
        );

        message.value = "Başarıyla bekleme listesine katıldın!";
        success.value = true;
        email.value = "";
      } catch (error: any) {
        const code = error.response?.data?.code;
        if (code === "23505") {
          message.value = "Bu e-posta zaten listede.";
        } else {
          message.value = error.response?.data?.message || "Bir hata oluştu. Lütfen tekrar dene.";
        }
        success.value = false;
      } finally {
        loading.value = false;
      }
    };

    return {
      email,
      loading,
      message,
      success,
      submitForm,
    };
  }
});
</script>
